module.exports = __webpack_public_path__ + "img/05.c3e25a26.jpg";